import { render, staticRenderFns } from "./tab-label.vue?vue&type=template&id=aeafbdb6&scoped=true"
import script from "./tab-label.vue?vue&type=script&lang=js"
export * from "./tab-label.vue?vue&type=script&lang=js"
import style0 from "./tab-label.vue?vue&type=style&index=0&id=aeafbdb6&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aeafbdb6",
  null
  
)

export default component.exports